import { render, staticRenderFns } from "./EmployeeAddUniform.vue?vue&type=template&id=f23ea574&scoped=true"
import script from "./EmployeeAddUniform.vue?vue&type=script&lang=js"
export * from "./EmployeeAddUniform.vue?vue&type=script&lang=js"
import style0 from "./EmployeeAddUniform.vue?vue&type=style&index=0&id=f23ea574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23ea574",
  null
  
)

export default component.exports